import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfigurationItem } from 'diwimamodelweb/lib';
import { SettingsService } from 'src/app/shared/settings.service';
// import { FilterSelectItem } from './../filter-game-record.service';
import { FilterSelectItem } from '../../statistics/filter.service';

export interface GrMultiSelectFilterDialogComponent {
  ref: FilterSelectItem
}

@Component({
  selector: 'app-gr-multi-select-filter-dialog',
  templateUrl: './gr-multi-select-filter-dialog.component.html',
  styleUrls: ['./gr-multi-select-filter-dialog.component.css']
})


export class GrMultiSelectFilterDialogComponent implements OnInit {

  
  selectedOptions: [{selected: boolean, item: ConfigurationItem}]

  constructor(
    public dialogRef: MatDialogRef<GrMultiSelectFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GrMultiSelectFilterDialogComponent,
    private settingsService: SettingsService
  ) { }

  ngOnInit(): void {}

  getTitle(item: ConfigurationItem) {
    if (item.title) return item.title
    else return item.names?.de
  }

  getOptionsForSpecificGroup(group){
    return this.data.ref.options.filter( options => options.item.optionGroup == group)
  }

  onAreaListControlChanged(list, group?:string) {
    this.data.ref.setActiveFilter(list.selectedOptions.selected.map(el => el.value), group)
  }

  selectAllOptionsFromGroup(list, group){
    const allSelected = this.data.ref.options.every( option => option.selected)
    const allSelectedList = this.data.ref.options?.length == list.selectedOptions.selected?.length
    this.data.ref.setSelectAllActiveFilter(list.options.toArray().map(el => el.value), group)
  }

  unselectAllOptionsFromGroup(list, group){
    const allUnselected = this.data.ref.options.every( option => option.selected)
    this.data.ref.setUnselectedAllActiveFilter(list.selectedOptions.selected.map(el => el.value), group)
  }

  showSelectUnselectButton(group){
    const list =  this.data.ref.options
    return list.filter( option => option.item.optionGroup == group).map(el=> el).every( option => option.selected)
  }
}


